import actionType from "./actionType";
import {State} from "./state";
import { Asset } from "../../interface/Server";
import { LocationBounds, LocationType } from "../../interface/Client";

export interface Action {
    type: actionType
    payload: {
        markers?: Array<Asset>
        selectedMarker?: Asset, // | CustomAssetChild
        mapBounds?: LocationBounds,
        center?: LocationType,
    }
}


const dispatch = (state: State, action: Action): State => {
    switch (action.type) {
        case actionType.GOOGLE_MAP_INIT_MARKER: {
            return ({
                ...state,
                markers: action.payload.markers ? action.payload.markers : []
            })
        }
        case actionType.GOOGLE_EDIT_SELECTED_MARKER:
            return ({
                ...state,
                selectedMarker: action.payload.selectedMarker // TODO update selected marker and nearby
            });
        case actionType.GOOGLE_MAP_RESET_MAP_BOUNDS:
            return ({
                ...state,
                mapBounds: undefined,
                center: undefined,
                selectedMarker: undefined,
        });
        case actionType.GOOGLE_MAP_SET_MAP_BOUNDS:
            return ({
                ...state,
                mapBounds: action.payload.mapBounds,
                center: action.payload.center,
            });
        default:
            return state
    }
};


export default dispatch

